import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { questionShape } from "utils/propTypeShapes"
import { FormsyTextInput } from "shared/inputs"

const FullNameField = ({
  className = "",
  disabled = false,
  edit = false,
  hasBaseInputStyle = false,
  initialValue = null,
  placeholder = "",
  question,
  ...rest
}) => {
  const { required, uuid } = question

  const validations = {
    noExcelMetacharacters: true,
    noHTML: true,
  }

  if (required && !edit) {
    validations.isNotBlankString = true
  }

  return (
    <FormsyTextInput
      className={clsx("form-input", className)}
      name={uuid}
      value={initialValue ?? ""}
      validations={validations}
      disabled={disabled}
      placeholder={placeholder}
      hasBaseInputStyle={hasBaseInputStyle}
      {...rest}
    />
  )
}

FullNameField.propTypes = {
  edit: types.bool,
  question: questionShape.isRequired,
  initialValue: types.string,
  disabled: types.bool,
  className: types.string,
  placeholder: types.string,
  hasBaseInputStyle: types.bool,
}

export default FullNameField
